<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card tp-box">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i>
							Dispatch
						</h4>
						<div class="card-category" *ngIf="order.header">
							<div class="row m-0 p-0">
								<div class="col-4">

								</div>
								<div class="col-8 text-right">
									<b><a href="#" (click)="$event.preventDefault();copyText(debtorno);"> {{ debtorno }}.{{ branchcode }}</a> &nbsp;&nbsp; {{ order.header.name }} &nbsp;&nbsp;&nbsp; #<a href="#" (click)="$event.preventDefault();copyText(orderno);">{{ orderno }}</a></b>
										
								</div>
							</div>
						</div>
					</div>
					<div class="card-body">
						<ng-container *ngIf="orderno" >
							<nav class="navbar navbar-expand navbar-light bg-light no-shadow nobox" @navIn>
							</nav>
							<app-order-invoice [orderno]="orderno" [ctlordirect]="'direct'" (reloadCustomer)="emitCustomerUpdate($event);" (invoiced)="showInvoiceResultandReset($event)" *ngIf="orderno"> </app-order-invoice>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
